export default __webpack_public_path__ + "static/media/PAYROLL-elements.a4771ba7.png";